import React from 'react';
import { useTranslation } from 'react-i18next';

import { Checkbox, PrimaryButton } from '@dev/ee-components';

import { STEPS, ButtonFooter } from '../..';
import { TermsConfirmationProps } from '../../ContactsUpload';

export const TermsConfirmation = (props: TermsConfirmationProps): JSX.Element => {
    const { t } = useTranslation();
    const { termsAccepted, setTermsAccepted, setCurrentStep } = props;

    return (
        <div>
            <Checkbox
                id="confirmation-of-terms-checkbox"
                name="confirmationofterms"
                value={false}
                disabled={false}
                required={true}
                label={t('descconsentsub')}
                onChange={(e, checked): void => setTermsAccepted(checked)}
                indeterminate={false}
                labelPlacement="end"
            />
            <ButtonFooter>
                <PrimaryButton
                    id="continue-button"
                    disabled={!termsAccepted}
                    text={t('continue')}
                    onClick={(): void => {
                        setCurrentStep(STEPS.SOURCE_SELECTION);
                    }}
                />
            </ButtonFooter>
        </div>
    );
};
